export { ErrorPageHeader } from './errorPageHeader.component';
